<template>
	<div class="wrapper">
		<div class="block-center mt-4 wd-xxl">
			<div class="text-center mt-4 mb-4">
				<a href="../" title="TLT"> <img src="/static/logo.png" alt="TLT logo" class="tbt-logo"></a>
			</div>
			<div class="card card-flat">
				<div class="card-header text-center bg-dark-green">
					<h4 class="text-white m-0">{{ $t('global.client-name') }}</h4>
				</div>
				<div class="card-body">

          <!--    STEP ONE      -->

					<div class="step-one" v-if="formStep === 1">
						<form class="form-modal form-register">
							<h4 class="text-center py-2">{{ $t('register.new-supplier') }}</h4>

							<div class="form-group">
								<label class="text-muted" for="supplier_name">{{ $t('register.company-name') }}
									*</label>
								<input
										v-model="supplier.name"
										:class="{'parsley-error': errors.supplier_name}"
										class="form-control"
										type="text"
										id="supplier_name"
										:placeholder="$t('register.insert-company-name')"
										autocomplete="off"
                    ref="supplier_name"
								>
								<ul class="parsley-errors-list filled" v-if="errors.supplier_name">
									<li class="parsley-required">{{ errors.supplier_name[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="supplier_registration_code">{{
									$t('register.registration-code') }} *</label>
								<input
										v-model="supplier.registration_code"
										:class="{'parsley-error': errors.supplier_registration_code}"
										class="form-control"
										type="text"
										id="supplier_registration_code"
										:placeholder="$t('register.insert-registration-code')"
										autocomplete="off"
                    ref="supplier_registration_code"
								>
								<ul class="parsley-errors-list filled" v-if="errors.supplier_registration_code">
									<li class="parsley-required">{{ errors.supplier_registration_code[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="company_address">{{ $t('register.address') }} *</label>
								<input
										v-model="supplier.address"
										:class="{'parsley-error': errors.supplier_address}"
										class="form-control"
										type="text"
										id="company_address"
										:placeholder="$t('register.address')"
										autocomplete="off"
                    ref="supplier_address"
								>
								<ul class="parsley-errors-list filled" v-if="errors.supplier_address">
									<li class="parsley-required">{{ errors.supplier_address[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="company_country">{{ $t('register.country') }} *</label>
								<select
                    v-model="supplier.country_code"
                    class="custom-select custom-select-md mb-3"
                    id="company_country"
                >
									<option disabled value="">{{ $t('register.select-country')}}</option>
									<option v-for="(country, idx) in countries" :key="idx" :value="country.code">
										{{country.name}}
									</option>
								</select>
								<ul class="parsley-errors-list filled" v-if="errors.company_country">
									<li class="parsley-required">{{ errors.company_country[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="user_email">{{ $t('register.email') }} *</label>
								<input
										v-model="supplier.email"
										:class="{'parsley-error': errors.supplier_email}"
										class="form-control"
										type="text"
										id="user_email"
										:placeholder="$t('register.email')"
										autocomplete="off"
                    ref="supplier_email"
								>
								<ul class="parsley-errors-list filled" v-if="errors.supplier_email">
									<li class="parsley-required">{{ errors.supplier_email[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="col-form-label">{{ $t('register.notes')}}</label>

								<textarea
                    rows="5"
                    class="form-control note-editor"
                    :placeholder="$t('register.notes_placeholder')"
                    :class="{'parsley-error': errors.supplier_notes}"
                    v-model="supplier.notes"
                    ref="supplier_notes"
                ></textarea>
								<ul class="parsley-errors-list filled" v-if="errors.supplier_notes">
									<li class="parsley-required">{{ errors.supplier_notes[0] }}</li>
								</ul>

							</div>
							<button @click.prevent="validateSupplierData()" class="btn btn-block btn-success mt-3"
									type="button">{{ $t('register.next-step') }}
							</button>
						</form>
					</div>

          <!--    STEP TWO      -->

					<div @submit.prevent="register" class="step-two" v-if="formStep === 2">
						<form class="form-modal form-register">
							<h4 class="text-center py-2">{{ $t('register.new-master') }}</h4>

							<div class="form-group">
								<label class="text-muted" for="user_first_name">{{ $t('register.user-first-name') }}
									*</label>
								<input
										v-model="supplieruser.first_name"
										:class="{'parsley-error': validation.user_first_name}"
										class="form-control"
										type="text"
										id="user_first_name"
										:placeholder="$t('register.first-name')"
										autocomplete="off"
                    ref="user_first_name"
								>
								<ul class="parsley-errors-list filled" v-if="validation.user_first_name">
									<li class="parsley-required">{{ validation.user_first_name[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="user_last_name">{{ $t('register.user-last-name') }}
									*</label>
								<input
										v-model="supplieruser.last_name"
										:class="{'parsley-error': validation.user_last_name}"
										class="form-control"
										type="text"
										id="user_last_name"
										:placeholder="$t('register.last-name')"
										autocomplete="off"
                    ref="user_last_name"
								>
								<ul class="parsley-errors-list filled" v-if="validation.user_last_name">
									<li class="parsley-required">{{ validation.user_last_name[0] }}</li>
								</ul>
							</div>

							<div class="form-group" v-if="supplier.country_code === 'EE'">
								<label class="text-muted" for="user_personal_code">{{ $t('register.personal-code')
									}}</label>
								<input
										v-model="supplieruser.personal_code"
										:class="{'parsley-error': validation.user_personal_code}"
										class="form-control"
										type="number"
										id="user_personal_code"
										:placeholder="$t('register.personal-code')"
										autocomplete="off"
                    ref="user_personal_code"
								>
								<ul class="parsley-errors-list filled" v-if="validation.user_personal_code">
									<li class="parsley-required">{{ validation.user_personal_code[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="user_job_title">{{ $t('register.job-title') }}</label>
								<input
										v-model="supplieruser.job_title"
										:class="{'parsley-error': validation.user_job_title}"
										class="form-control"
										type="text"
										id="user_job_title"
										:placeholder="$t('register.job-title')"
										autocomplete="off"
								>
								<ul class="parsley-errors-list filled" v-if="validation.user_job_title">
									<li class="parsley-required">{{ validation.user_job_title[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="notification_lang">{{ $t('register.notification_lang') }}
									*</label>
								<select
                    v-model="supplieruser.notification_lang"
										class="custom-select custom-select-md mb-3"
                    id="notification_lang"
                >
									<option disabled value="">{{ $t('register.notification_lang')}}</option>
									<option value="et">Eesti</option>
									<option value="en">Inglise</option>
									<option value="ru">Vene</option>
								</select>
								<ul class="parsley-errors-list filled" v-if="validation.notification_lang">
									<li class="parsley-required">{{ validation.notification_lang[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="user_phone">{{ $t('register.phone') }} *</label>

								<input
										v-model="supplieruser.phone"
										:class="{'parsley-error': validation.user_phone}"
										class="form-control"
										type="text"
										id="user_phone"
										:placeholder="$t('register.phone')"
										autocomplete="off"
                    ref="user_phone"
								>
								<ul class="parsley-errors-list filled" v-if="validation.user_phone">
									<li class="parsley-required">{{ validation.user_phone[0] }}</li>
								</ul>
							</div>

							<div class="form-group">
								<label class="text-muted" for="supplier_email">{{ $t('register.email') }} *</label>
								<input
										v-model="supplieruser.email"
										:class="{'parsley-error': validation.user_email}"
										class="form-control"
										type="text"
										id="supplier_email"
										:placeholder="$t('register.email')"
										autocomplete="off"
                    ref="user_email"
								>
								<ul class="parsley-errors-list filled" v-if="validation.user_email">
									<li class="parsley-required">{{ validation.user_email[0] }}</li>
								</ul>
							</div>

							<div class="checkbox c-checkbox mt-0">
								<label for="agreed">
									<input
											v-model="supplieruser.agreed"
											:class="{'parsley-error': errors.agree}"
											class="form-control"
											type="checkbox"
											id="agreed"
											value="1"
                      @change="clear_error"
                      ref="agreed"
									>
									<span class="fa fa-check"></span> {{ $t('register.agree') }}
									<span class="btn btn-link" @click="show_modal" style="padding: 1px;">{{ $t('register.terms') }}</span>
								</label>
								<ul class="parsley-errors-list filled" v-if="validation.agreed">
									<li class="parsley-required">{{ validation.agreed[0] }}</li>
								</ul>
							</div>
							<button class="btn btn-block btn-success mt-3" type="submit">{{ $t('register.register-new')
								}}
							</button>

						</form>
					</div>

					<p class="pt-3 text-center">{{ $t('register.account-exist') }}</p>
					<a class="btn btn-block btn-secondary" href="/">{{ $t('register.login') }}</a>
				</div>
			</div>
		</div>
		<div class="p-3 text-center">
			<span>{{ $t('global.soft-year') }} {{ $t('global.soft-name') }}</span>
		</div>
		<modal name="terms-and-conditions" height="auto" :scrollable="true">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">{{ $t('register.modal.terms-of-use-title') }}</h4>
					<button class="close" type="button" data-dismiss="modal" aria-label="Close"
							@click="$modal.hide('terms-and-conditions')">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div
          class="modal-body"
          v-html="$t('register.modal.terms')"
        ></div>
			</div>
			<div slot="modal_buttons">
				<button class="btn btn-secondary" type="button" @click="close_modal()">{{ $t('modal.close') }}</button>
			</div>
		</modal>
	</div>
</template>

<script>
	import api from '@/api'
	import message from '@/message'
	import {parseApiError, isValidEmail, getFirstInvalid} from '@/utils'

	export default {
		mounted() {
			this.$i18n.locale = this.$store.getters.language
			if(localStorage.getItem('etend.language') == null){
				this.set_language('et-EE')

			} else {
				this.set_language(localStorage.getItem('etend.language'))
			}
		},
		data() {
			return {

				supplier_name: null,
				supplier_registration_code: null,
				user_first_name: null,
				user_last_name: null,
				user_personal_code: null,
				user_email: null,
				user_phone: null,
				company_address: null,
				company_country: 'EE',
				agreed: null,
				validation:{},
				errors: {
					supplier_name: null,
					supplier_registration_code: null,
					supplier_address: null,
					supplier_country: null,
					supplier_email: null,
					supplier_notes:null,
					agree:null,
				},
				formStep: 1,
				notification_lang: 0,
				phone_region: '+372',
				user_job_title: null,
				countries: [
					{name: 'Afghanistan', code: 'AF'},
					{name: 'Åland Islands', code: 'AX'},
					{name: 'Albania', code: 'AL'},
					{name: 'Algeria', code: 'DZ'},
					{name: 'American Samoa', code: 'AS'},
					{name: 'AndorrA', code: 'AD'},
					{name: 'Angola', code: 'AO'},
					{name: 'Anguilla', code: 'AI'},
					{name: 'Antarctica', code: 'AQ'},
					{name: 'Antigua and Barbuda', code: 'AG'},
					{name: 'Argentina', code: 'AR'},
					{name: 'Armenia', code: 'AM'},
					{name: 'Aruba', code: 'AW'},
					{name: 'Australia', code: 'AU'},
					{name: 'Austria', code: 'AT'},
					{name: 'Azerbaijan', code: 'AZ'},
					{name: 'Bahamas', code: 'BS'},
					{name: 'Bahrain', code: 'BH'},
					{name: 'Bangladesh', code: 'BD'},
					{name: 'Barbados', code: 'BB'},
					{name: 'Belarus', code: 'BY'},
					{name: 'Belgium', code: 'BE'},
					{name: 'Belize', code: 'BZ'},
					{name: 'Benin', code: 'BJ'},
					{name: 'Bermuda', code: 'BM'},
					{name: 'Bhutan', code: 'BT'},
					{name: 'Bolivia', code: 'BO'},
					{name: 'Bosnia and Herzegovina', code: 'BA'},
					{name: 'Botswana', code: 'BW'},
					{name: 'Bouvet Island', code: 'BV'},
					{name: 'Brazil', code: 'BR'},
					{name: 'British Indian Ocean Territory', code: 'IO'},
					{name: 'Brunei Darussalam', code: 'BN'},
					{name: 'Bulgaria', code: 'BG'},
					{name: 'Burkina Faso', code: 'BF'},
					{name: 'Burundi', code: 'BI'},
					{name: 'Cambodia', code: 'KH'},
					{name: 'Cameroon', code: 'CM'},
					{name: 'Canada', code: 'CA'},
					{name: 'Cape Verde', code: 'CV'},
					{name: 'Cayman Islands', code: 'KY'},
					{name: 'Central African Republic', code: 'CF'},
					{name: 'Chad', code: 'TD'},
					{name: 'Chile', code: 'CL'},
					{name: 'China', code: 'CN'},
					{name: 'Christmas Island', code: 'CX'},
					{name: 'Cocos (Keeling) Islands', code: 'CC'},
					{name: 'Colombia', code: 'CO'},
					{name: 'Comoros', code: 'KM'},
					{name: 'Congo', code: 'CG'},
					{name: 'Congo, The Democratic Republic of the', code: 'CD'},
					{name: 'Cook Islands', code: 'CK'},
					{name: 'Costa Rica', code: 'CR'},
					{name: 'Cote D\'Ivoire', code: 'CI'},
					{name: 'Croatia', code: 'HR'},
					{name: 'Cuba', code: 'CU'},
					{name: 'Cyprus', code: 'CY'},
					{name: 'Czech Republic', code: 'CZ'},
					{name: 'Denmark', code: 'DK'},
					{name: 'Djibouti', code: 'DJ'},
					{name: 'Dominica', code: 'DM'},
					{name: 'Dominican Republic', code: 'DO'},
					{name: 'Ecuador', code: 'EC'},
					{name: 'Egypt', code: 'EG'},
					{name: 'El Salvador', code: 'SV'},
					{name: 'Equatorial Guinea', code: 'GQ'},
					{name: 'Eritrea', code: 'ER'},
					{name: 'Estonia', code: 'EE'},
					{name: 'Ethiopia', code: 'ET'},
					{name: 'Falkland Islands (Malvinas)', code: 'FK'},
					{name: 'Faroe Islands', code: 'FO'},
					{name: 'Fiji', code: 'FJ'},
					{name: 'Finland', code: 'FI'},
					{name: 'France', code: 'FR'},
					{name: 'French Guiana', code: 'GF'},
					{name: 'French Polynesia', code: 'PF'},
					{name: 'French Southern Territories', code: 'TF'},
					{name: 'Gabon', code: 'GA'},
					{name: 'Gambia', code: 'GM'},
					{name: 'Georgia', code: 'GE'},
					{name: 'Germany', code: 'DE'},
					{name: 'Ghana', code: 'GH'},
					{name: 'Gibraltar', code: 'GI'},
					{name: 'Greece', code: 'GR'},
					{name: 'Greenland', code: 'GL'},
					{name: 'Grenada', code: 'GD'},
					{name: 'Guadeloupe', code: 'GP'},
					{name: 'Guam', code: 'GU'},
					{name: 'Guatemala', code: 'GT'},
					{name: 'Guernsey', code: 'GG'},
					{name: 'Guinea', code: 'GN'},
					{name: 'Guinea-Bissau', code: 'GW'},
					{name: 'Guyana', code: 'GY'},
					{name: 'Haiti', code: 'HT'},
					{name: 'Heard Island and Mcdonald Islands', code: 'HM'},
					{name: 'Holy See (Vatican City State)', code: 'VA'},
					{name: 'Honduras', code: 'HN'},
					{name: 'Hong Kong', code: 'HK'},
					{name: 'Hungary', code: 'HU'},
					{name: 'Iceland', code: 'IS'},
					{name: 'India', code: 'IN'},
					{name: 'Indonesia', code: 'ID'},
					{name: 'Iran, Islamic Republic Of', code: 'IR'},
					{name: 'Iraq', code: 'IQ'},
					{name: 'Ireland', code: 'IE'},
					{name: 'Isle of Man', code: 'IM'},
					{name: 'Israel', code: 'IL'},
					{name: 'Italy', code: 'IT'},
					{name: 'Jamaica', code: 'JM'},
					{name: 'Japan', code: 'JP'},
					{name: 'Jersey', code: 'JE'},
					{name: 'Jordan', code: 'JO'},
					{name: 'Kazakhstan', code: 'KZ'},
					{name: 'Kenya', code: 'KE'},
					{name: 'Kiribati', code: 'KI'},
					{name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
					{name: 'Korea, Republic of', code: 'KR'},
					{name: 'Kuwait', code: 'KW'},
					{name: 'Kyrgyzstan', code: 'KG'},
					{name: 'Lao People\'S Democratic Republic', code: 'LA'},
					{name: 'Latvia', code: 'LV'},
					{name: 'Lebanon', code: 'LB'},
					{name: 'Lesotho', code: 'LS'},
					{name: 'Liberia', code: 'LR'},
					{name: 'Libyan Arab Jamahiriya', code: 'LY'},
					{name: 'Liechtenstein', code: 'LI'},
					{name: 'Lithuania', code: 'LT'},
					{name: 'Luxembourg', code: 'LU'},
					{name: 'Macao', code: 'MO'},
					{name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
					{name: 'Madagascar', code: 'MG'},
					{name: 'Malawi', code: 'MW'},
					{name: 'Malaysia', code: 'MY'},
					{name: 'Maldives', code: 'MV'},
					{name: 'Mali', code: 'ML'},
					{name: 'Malta', code: 'MT'},
					{name: 'Marshall Islands', code: 'MH'},
					{name: 'Martinique', code: 'MQ'},
					{name: 'Mauritania', code: 'MR'},
					{name: 'Mauritius', code: 'MU'},
					{name: 'Mayotte', code: 'YT'},
					{name: 'Mexico', code: 'MX'},
					{name: 'Micronesia, Federated States of', code: 'FM'},
					{name: 'Moldova, Republic of', code: 'MD'},
					{name: 'Monaco', code: 'MC'},
					{name: 'Mongolia', code: 'MN'},
					{name: 'Montserrat', code: 'MS'},
					{name: 'Morocco', code: 'MA'},
					{name: 'Mozambique', code: 'MZ'},
					{name: 'Myanmar', code: 'MM'},
					{name: 'Namibia', code: 'NA'},
					{name: 'Nauru', code: 'NR'},
					{name: 'Nepal', code: 'NP'},
					{name: 'Netherlands', code: 'NL'},
					{name: 'Netherlands Antilles', code: 'AN'},
					{name: 'New Caledonia', code: 'NC'},
					{name: 'New Zealand', code: 'NZ'},
					{name: 'Nicaragua', code: 'NI'},
					{name: 'Niger', code: 'NE'},
					{name: 'Nigeria', code: 'NG'},
					{name: 'Niue', code: 'NU'},
					{name: 'Norfolk Island', code: 'NF'},
					{name: 'Northern Mariana Islands', code: 'MP'},
					{name: 'Norway', code: 'NO'},
					{name: 'Oman', code: 'OM'},
					{name: 'Pakistan', code: 'PK'},
					{name: 'Palau', code: 'PW'},
					{name: 'Palestinian Territory, Occupied', code: 'PS'},
					{name: 'Panama', code: 'PA'},
					{name: 'Papua New Guinea', code: 'PG'},
					{name: 'Paraguay', code: 'PY'},
					{name: 'Peru', code: 'PE'},
					{name: 'Philippines', code: 'PH'},
					{name: 'Pitcairn', code: 'PN'},
					{name: 'Poland', code: 'PL'},
					{name: 'Portugal', code: 'PT'},
					{name: 'Puerto Rico', code: 'PR'},
					{name: 'Qatar', code: 'QA'},
					{name: 'Reunion', code: 'RE'},
					{name: 'Romania', code: 'RO'},
					{name: 'Russian Federation', code: 'RU'},
					{name: 'RWANDA', code: 'RW'},
					{name: 'Saint Helena', code: 'SH'},
					{name: 'Saint Kitts and Nevis', code: 'KN'},
					{name: 'Saint Lucia', code: 'LC'},
					{name: 'Saint Pierre and Miquelon', code: 'PM'},
					{name: 'Saint Vincent and the Grenadines', code: 'VC'},
					{name: 'Samoa', code: 'WS'},
					{name: 'San Marino', code: 'SM'},
					{name: 'Sao Tome and Principe', code: 'ST'},
					{name: 'Saudi Arabia', code: 'SA'},
					{name: 'Senegal', code: 'SN'},
					{name: 'Serbia and Montenegro', code: 'CS'},
					{name: 'Seychelles', code: 'SC'},
					{name: 'Sierra Leone', code: 'SL'},
					{name: 'Singapore', code: 'SG'},
					{name: 'Slovakia', code: 'SK'},
					{name: 'Slovenia', code: 'SI'},
					{name: 'Solomon Islands', code: 'SB'},
					{name: 'Somalia', code: 'SO'},
					{name: 'South Africa', code: 'ZA'},
					{name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
					{name: 'Spain', code: 'ES'},
					{name: 'Sri Lanka', code: 'LK'},
					{name: 'Sudan', code: 'SD'},
					{name: 'Suriname', code: 'SR'},
					{name: 'Svalbard and Jan Mayen', code: 'SJ'},
					{name: 'Swaziland', code: 'SZ'},
					{name: 'Sweden', code: 'SE'},
					{name: 'Switzerland', code: 'CH'},
					{name: 'Syrian Arab Republic', code: 'SY'},
					{name: 'Taiwan, Province of China', code: 'TW'},
					{name: 'Tajikistan', code: 'TJ'},
					{name: 'Tanzania, United Republic of', code: 'TZ'},
					{name: 'Thailand', code: 'TH'},
					{name: 'Timor-Leste', code: 'TL'},
					{name: 'Togo', code: 'TG'},
					{name: 'Tokelau', code: 'TK'},
					{name: 'Tonga', code: 'TO'},
					{name: 'Trinidad and Tobago', code: 'TT'},
					{name: 'Tunisia', code: 'TN'},
					{name: 'Turkey', code: 'TR'},
					{name: 'Turkmenistan', code: 'TM'},
					{name: 'Turks and Caicos Islands', code: 'TC'},
					{name: 'Tuvalu', code: 'TV'},
					{name: 'Uganda', code: 'UG'},
					{name: 'Ukraine', code: 'UA'},
					{name: 'United Arab Emirates', code: 'AE'},
					{name: 'United Kingdom', code: 'GB'},
					{name: 'United States', code: 'US'},
					{name: 'United States Minor Outlying Islands', code: 'UM'},
					{name: 'Uruguay', code: 'UY'},
					{name: 'Uzbekistan', code: 'UZ'},
					{name: 'Vanuatu', code: 'VU'},
					{name: 'Venezuela', code: 'VE'},
					{name: 'Viet Nam', code: 'VN'},
					{name: 'Virgin Islands, British', code: 'VG'},
					{name: 'Virgin Islands, U.S.', code: 'VI'},
					{name: 'Wallis and Futuna', code: 'WF'},
					{name: 'Western Sahara', code: 'EH'},
					{name: 'Yemen', code: 'YE'},
					{name: 'Zambia', code: 'ZM'},
					{name: 'Zimbabwe', code: 'ZW'}
				],
				supplieruser: {
					first_name: null,
					last_name: null,
					personal_code: null,
					phone_region: '+372',
					phone: null,
					email: null,
					agreed: false,
					job_title: null,
					is_admin: true,
					role: 'ADVANCED',
					notification_lang: 'et',
				},
				supplier: {
					name: null,
					registration_code: null,
					address: '',
					country_code: 'EE',
					email: null,
					notes: null,
				}

			}
		},
		methods: {
			set_language(lang) {
				this.$store.dispatch('setLanguage', lang)
				this.language = lang
				this.$i18n.locale = lang
			},
      validateSupplierData: function () {
        let errors = false;

        if (this.formStep === 1) {

          // Validate company name, reg code, address, country, email
          if (this.supplier.name == null || this.supplier.name.length < 3) {
            this.errors.supplier_name = [this.$i18n.t('register.validation.supplier.supplier_name'),];
            errors = true;
          } else {
            this.errors.supplier_name = null;
          }

          if (this.supplier.registration_code == null
              || this.supplier.registration_code.length < 5) {
            this.errors.supplier_registration_code = [this.$i18n.t('register.validation.supplier.reg_code'),];
            errors = true;

          } else {
            this.errors.supplier_registration_code = null;
          }

          if (this.supplier.address == null
              || this.supplier.address.length < 5
              || this.supplier.address === "") {
            this.errors.supplier_address = [this.$i18n.t('register.validation.supplier.supplier_address'),];
            errors = true;

          } else {
            this.errors.supplier_address = null;
          }

          if (this.supplier.country_code == null
              || this.supplier.country_code.length < 2) {
            this.errors.country_code = [this.$i18n.t('register.validation.supplier.country_code'),];
            errors = true;

          } else {
            this.errors.country_code = null;
          }

          if (this.supplier.email == null
              || this.supplier.email.length < 5
              || !isValidEmail(this.supplier.email)) {
            this.errors.supplier_email = [this.$i18n.t('register.validation.supplier.email'),];
            errors = true;

          } else {
            this.errors.supplier_email = null;
          }

          if (this.supplier.notes == null || this.supplier.notes.length < 5) {
            this.errors.supplier_notes = [this.$i18n.t('register.validation.supplier.notes'),];
            errors = true;

          } else {
            this.errors.supplier_notes = null;
          }

          if (errors) {
            let field_name = getFirstInvalid(this.errors)
            this.$refs[field_name].focus()
          } else {
            api.post('register/?step=1', {
              supplier_country_code: this.supplier.country_code,
              supplier_name: this.supplier.name,
              supplier_registration_code: this.supplier.registration_code,
              supplier_notes: this.supplier.notes,
              supplier_address: this.supplier.address,
              supplier_email: this.supplier.email
            })
            .then(() => {
              this.formStep = 2
            })
            .catch(error => {
              if (error.response && error.response.status === 400) {
                this.errors = parseApiError(error, this.$i18n)

                let field_name = getFirstInvalid(this.errors)
                this.$refs[field_name].focus()
              }
            })
          }
        }
      },
			show_modal() {
				this.$modal.show('terms-and-conditions')
			},
			hide() {
				this.$modal.hide('terms-and-conditions')
			},
			register() {
				this.errors = {}

				if (this.formStep === 2) {
          api.post('/register/', {
            supplier_country_code: this.supplier.country_code,
            supplier_email: this.supplier.email,
            supplier_address: this.supplier.address,
            supplier_name: this.supplier.name,
            supplier_registration_code: this.supplier.registration_code,
            supplier_notes: this.supplier.notes,

            //User
            user_first_name: this.supplieruser.first_name,
            user_last_name: this.supplieruser.last_name,
            user_email: this.supplieruser.email,
            user_phone: this.supplieruser.phone,
            user_personal_code: this.supplieruser.personal_code ? this.supplieruser.personal_code : null,
            user_position: this.supplieruser.job_title,
            user_language_code: this.supplieruser.notification_lang,

            //Agreed terms
            agreed: this.supplieruser.agreed
          })
          .then(() => {
            message.success(this.$i18n.t('register.success'))
            this.$router.push({path: '/'})
          })
          .catch(error => {
            if (error.response && error.response.status === 400) {
              this.validation  = parseApiError(error, this.$i18n)

              let validationOrder = ['user_first_name', 'user_last_name', 'user_personal_code', 'user_phone', 'user_email', 'agreed']
              let field_name = getFirstInvalid(this.validation, validationOrder)
              this.$refs[field_name].focus()
            }
          })
        }
			},
      clear_error(e) {
			  if (e.target.checked) {
          this.errors.agree = null
        }
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/Register.vue